import { RandomStringService } from './random-string.service';
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
//const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
import { EncrdecrService } from '../Auth/encrdecr.service';
import { catchError } from 'rxjs/operators';
import { ThrowStmt } from '@angular/compiler';
import { ConfigService } from '../config.service';
const headers = {
  headers: new HttpHeaders({ 'content-type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  AuthData: string;
  GlobalARN: string;
  get ServerUrl5() { return this.serverConfig.ServerUrl5 }
  get ServerUrl9() { return this.serverConfig.ServerUrl9 }
  get ServerUrl() { return this.serverConfig.ServerUrl }
  errorData: {};
  constructor(
    private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private randomString: RandomStringService,
    private serverConfig: ConfigService
  ) { }

  PostLoginInfo(
    formData: any,
    UserType: number,
    IP: string = ''
  ): Observable<any> {
    ////////
    debugger;
    //this.ServerUrl5 =`http://localhost:1857/`;
    let DataUrl = `${this.ServerUrl5}/api/Authenticate/Authenticate`;
    let fd = JSON.parse(formData);
    if (UserType === 2) {
      fd.Username = `ARN-${fd.Username}`;
    }
    let un = this.EncrdecrService.setEncr(fd.Username);
    let pd = this.EncrdecrService.setEncr(fd.Password);
    let ut = UserType;
    let SB = this.EncrdecrService.setEncr(fd.SB_ID);
    let TOKEN = btoa(`${un}:${pd}:${ut}:${SB}`);

    //alert(TOKEN);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    debugger;
    return this.http
      .post<any>(DataUrl, '', httpOptions)
      .pipe(catchError(this.handleError));
    // let DataUrl = `${this.ServerUrl9}/api/Authenticate/Authenticate`;
    // let fd = JSON.parse(formData);
    // // if(UserType === 2){
    // //   fd.Username = `ARN-${fd.Username}`
    // // }
    // //console.log(fd);
    // let un = this.EncrdecrService.setEncr(fd.Username);

    // let pd = this.EncrdecrService.setEncr(fd.Password);

    // let ut = UserType;
    // let ip = this.EncrdecrService.setEncr(IP);

    // //console.log('un=' + un + '\npd =' + pd);
    // //////
    // let TOKEN = btoa(`${un}:${pd}:${ut}`);  //:${ip}
    // let req ={
    //   "USER_ID":un,
    //   "PWD":pd,
    //   "USER_TYPE":ut,
    //   "IPAddress":ip
    // }
    // const jsonbody = JSON.stringify(req);
    // const httpOptions = {
    //   headers:
    //   new HttpHeaders(
    //     {'Content-Type': 'application/json', 'Authorization': `Basic ${TOKEN}`})
    // }
    // return this.http.post<any>(DataUrl, jsonbody, httpOptions).pipe(
    //   catchError(this.handleError)
    // );
  }

  //SaveLogFrontEnd(msg:string,exception:string): Observable<any> {
  //  let DataUrl = `${this.ServerUrl}/api/ErrorLog/FrontEndLog?Message=${msg}&Exception=${exception}`;
  //  return this.http.get<any>(DataUrl).pipe();
  //}

  //SaveLogBackEnd(msg:string,exception:string): Observable<any> {
  //  let DataUrl = `${this.ServerUrl}/api/ErrorLog/BackEndLog?Message=${msg}&Exception=${exception}`;
  //  return this.http.get<any>(DataUrl).pipe();
  //}

  Logout(TokenID: string): Observable<any> {
    debugger;
    let DataUrl = `${this.ServerUrl5}/api/Logout/Logout?TOKEN_ID=${TokenID}`;
    console.log(DataUrl);
    console.log(TokenID);
    const req = {
      //"TOKEN_ID":TokenID.split('-')[0]
    };

    const body = JSON.stringify(req);
    console.log(body);
    return this.http.post<any>(DataUrl, '', headers).pipe();
  }

  SendOTP(body): Observable<any[]> {
    let url = `${this.ServerUrl5}/api/OTP/Details`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }

  VerifyOTP(body): Observable<any[]> {
    let url = `${this.ServerUrl5}/api/Forgotpass/VerifyOTP`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }

  ChangePassword(formData): Observable<any[]> {
    ////////
    let url = `${this.ServerUrl5}/api/Forgotpass/Details`;
    return this.http.post<any>(url, formData, headers).pipe();
  }

  //-----------------------------------------------------------------------
  PostLogin_NSE_Info(
    formData: any,
    UserType: number,
    IP: string = ''
  ): Observable<any> {
    let DataUrl = `${this.ServerUrl9}/api/Authenticate/Authenticate`;
    let fd = JSON.parse(formData);
    let key = this.EncrdecrService.setEncr(this.randomString.getString(6));
    let un = this.EncrdecrService.setEncr(fd.Username);
    let pd = this.EncrdecrService.setEncr(fd.Password);
    pd = this.EncrdecrService.setEncr(pd + '`' + key);
    let ut = UserType;
    let ip = this.EncrdecrService.setEncr(IP);
    let TOKEN = btoa(`${un}:${pd}:${ut}`);
    let req = {
      USER_ID: un,
      PWD: pd,
      USER_TYPE: ut,
      IPAddress: ip
    };
    const jsonbody = JSON.stringify(req);
    console.log('DataUrl ' + DataUrl);
    console.log('jsonbody ' + jsonbody);
    console.log('header value  ' + `Authorization : ${key}`);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${key}`
      })
    };

    return this.http
      .post<any>(DataUrl, jsonbody, httpOptions)
      .pipe(catchError(this.handleError));
  }

  SendOTP_NSE(body): Observable<any[]> {
    let url = `${this.ServerUrl9}/api/OTP`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }

  VerifyOTP_NSE(body): Observable<any[]> {
    let url = `${this.ServerUrl9}/api/Forgotpass/VerifyOTP`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }

  ChangePassword_NSE(formData): Observable<any[]> {
    // this.ServerUrl9 = `http://localhost:9967/`
    // let req = this.EncrdecrService.setEncr(formData)
    let url = `${this.ServerUrl9}/api/Forgotpass/Details`;
    return this.http.post<any>(url, formData, headers).pipe();
  }
  //-----------------EMPLOYEE LOGIN-----------------------
  Post_EmployeeLogin(
    formData: any,
    UserType: number,
    IP: string = ''
  ): Observable<any> {
    let DataUrl = `${this.ServerUrl9}/api/Authenticate/Authenticate`;
    //let DataUrl = `${this.ServerUrl5}/api/Authenticate/Authenticate`;
    let fd = JSON.parse(formData);
    let un = this.EncrdecrService.setEncr(fd.Username);
    let key = this.EncrdecrService.setEncr(this.randomString.getString(6));
    let pd = this.EncrdecrService.setEncr(fd.Password);
    pd = this.EncrdecrService.setEncr(pd + '`' + key);
    let ut = UserType;
    let ip = this.EncrdecrService.setEncr(IP);
    //console.log('un=' + un + '\npd =' + pd);
    let TOKEN = btoa(`${un}:${pd}:${ut}`);
    let req = {
      USER_ID: un,
      PWD: pd,
      USER_TYPE: ut,
      IPAddress: ip
    };
    const jsonbody = JSON.stringify(req);
    console.log(jsonbody);
    console.log(key);
    debugger;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `${key}`
      })
    };
    console.log(DataUrl);
    return this.http
      .post<any>(DataUrl, jsonbody, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    ////////
    //if (error.error instanceof ErrorEvent) {
    //  console.error('An error occurred:', error.error.message);
    // // this.SaveLogFrontEnd(`${error.error.message}`,``);
    //} else {
    //  console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    //  //this.SaveLogBackEnd(`${error.error.message}`,`${error.error}`);
    //}
    // return an observable with a user-facing error message
    //this.errorData = {
    //  status: error.status,
    //  res: error.error
    //};
    return throwError(error);
  }

  test(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl5}/api/SMSService/SendOTP`;
    //console.log(DataUrl)
    return this.http.post<any>(DataUrl, formData, headers);
  }

  SaveUserData(formData): Observable<any[]> {
    let url = `${this.ServerUrl9}/api/MahindraUser/Details`;
    return this.http.post<any>(url, formData, headers).pipe();
  }

  SSOLogin(Token: string): Observable<any[]> {
    Token = Token.replace(/\+/g, '%2B');
    let url = `${this.ServerUrl9}/api/AutoLogin/Details?brokerToken=${Token}`;
    return this.http.get<any>(url, headers).pipe();
  }
  AlankitSSOLogin(Token: string): Observable<any[]> {
    Token = Token.replace(/\+/g, '%2B');
    let url = `${this.ServerUrl9}/api/AlankitSSO/Details?brokerToken=${Token}`;
    return this.http.get<any>(url, headers).pipe();
  }

  PostDomain(body: any): Observable<any> {
    let url = `${this.ServerUrl}/api/GetCompanydetails/reportingpersonemailpassing`;
    return this.http.post<any[]>(url, body, headers).pipe();
  }
  fetchClientDetailsBasedOnMobileOrEmail(data: any) {
    let url = `${this.ServerUrl}api/Login/FetchClientDetailsOnMobileOrEmail`;
    let request = { data: this.EncrdecrService.setEncr(data) };
    return this.http.post<any>(url, request, headers).pipe();
  }
  OTPMobile(formData: any): Observable<any[]> {
    let url = `${this.ServerUrl}/api/CommonOTP/SendOTPSMS`;
    const req = {
      data: this.EncrdecrService.setEncr(formData)
    };
    return this.http.post<any>(url, req, headers);
  }
  OTPEmail(formData: any): Observable<any[]> {
    let url = `${this.ServerUrl}/api/CommonOTP/SendEmailOTP`;
    const req = {
      data: this.EncrdecrService.setEncr(formData)
    };
    return this.http.post<any>(url, req, headers);
  }
}
